import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import TinyMCEViewer from "../../TinyMCEViewer";
import { calculateScore } from "../../utils";
import classes from './QuestionOptions.module.css'
import correct from '../../../assests/correct.svg';
import inCorrect from '../../../assests/inCorrect.svg';
import { FeedbackTypesEnum } from "../../../models/FeedbackTypesEnum";

const QuestionOptions = ({
    points,
    completed,
    options,
    multiple,
    survey,
    index,
    contentDirPath,
    handleChangeAnsData,
    submission,
    scoreByRetries,
    statusObject,
    feedback,
    ansData,
    sendInProgress,
    id }) => {

    const [values, setValues] = useState(options.map(opt => false));
    const [valueChanged, setValueChanged] = useState(false);

    useEffect(() => {
        if (valueChanged) {
            const correct = options.every((opt, i) => (opt.correct && values[i]) || (!opt.correct && !values[i])) || survey;
            const correctText = options.filter(o => o.correct).map(o => o.content);
            handleChangeAnsData({
                id: id,
                correct: correct,
                correctText: <TinyMCEViewer contentDirPath={contentDirPath} html={correctText.join(" ")}></TinyMCEViewer>,
                solution: values.find(opt => opt === true) ? JSON.stringify(values.map((x, i) => x ? i + 1 : false).filter(x => x)) : null,
                score: calculateScore(correct, submission?.attempts + 1 || 0, statusObject.retryConditions, scoreByRetries, points),
                success: correct ? correct : false
            })
        }
    }, [values]);


    const handleChange = (indexOpt, e) => {
        setValues(pre => {
            let newValues = [...pre];
            if (!multiple)
                newValues = newValues.map(v => false)
            newValues[indexOpt] = e.target.checked
            return newValues;
        })
        setValueChanged(true)
    }

    useEffect(() => {
        if (ansData?.solution) {
            const solution = JSON.parse(ansData.solution);
            setValues(pre => {
                let newValues = [...pre];
                newValues = pre.map((v, i) => solution.includes(i + 1))
                return newValues;
            })
        }
        else if (submission) {
            if (submission.solution) {
                const solution = JSON.parse(submission.solution);
                setValues(pre => {
                    let newValues = [...pre];
                    newValues = pre.map((v, i) => solution.includes(i + 1))
                    return newValues;
                })
                setValueChanged(false)
            }
        }
    }, [submission, id, index])


    const showOption = (opt, checked) => {
        if (feedback.show) {
            if (feedback.type === FeedbackTypesEnum.MaxRetries) {
                if (opt.correct)
                    return 'correctFlicker'
            }
            else if (checked) {
                if (opt.correct || survey)
                    return 'correct'
                else {
                    return 'inCorrect'
                }
            }
        }
        else if (checked)
            return 'correct';
    }


    return <div className={classes.QuestionOptions}>
        <div className={classes.OptionsList}>
            {options && options.map((opt, indexOpt) => {
                const showIcon = values[indexOpt] && feedback.show && !survey && feedback.type !== FeedbackTypesEnum.MaxRetries;
                return <div className={`${classes[showOption(opt, values[indexOpt])]} ${classes.Option}`} key={indexOpt}>
                    {showIcon && <img src={(opt.correct ? correct : inCorrect)} className={classes.Icon} />}
                    <input
                        className={classes.OptionInput}
                        onChange={(e) => handleChange(indexOpt, e)}
                        value={values[indexOpt]}
                        checked={values[indexOpt]}
                        disabled={completed || sendInProgress}
                        type={multiple ? 'checkbox' : 'radio'}
                        name={index + 'check-quetion-option-viewer'} />
                    <div className={classes.OptionContent}><TinyMCEViewer contentDirPath={contentDirPath} html={opt.content}></TinyMCEViewer></div>
                </div>
            })}
        </div>
    </div>

}
export default QuestionOptions;